/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseField } from './DatabaseField';
import {
    DatabaseFieldFromJSON,
    DatabaseFieldFromJSONTyped,
    DatabaseFieldToJSON,
} from './DatabaseField';
import type { DatabaseFieldPreviewOptions } from './DatabaseFieldPreviewOptions';
import {
    DatabaseFieldPreviewOptionsFromJSON,
    DatabaseFieldPreviewOptionsFromJSONTyped,
    DatabaseFieldPreviewOptionsToJSON,
} from './DatabaseFieldPreviewOptions';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';

/**
 * 
 * @export
 * @interface DatabaseTelnumberField
 */
export interface DatabaseTelnumberField extends DatabaseField {
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseTelnumberField
     */
    hasTelLink?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseTelnumberField
     */
    underlined?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DatabaseTelnumberField
     */
    color?: string;
}

/**
 * Check if a given object implements the DatabaseTelnumberField interface.
 */
export function instanceOfDatabaseTelnumberField(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseTelnumberFieldFromJSON(json: any): DatabaseTelnumberField {
    return DatabaseTelnumberFieldFromJSONTyped(json, false);
}

export function DatabaseTelnumberFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseTelnumberField {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...DatabaseFieldFromJSONTyped(json, ignoreDiscriminator),
        'hasTelLink': !exists(json, 'has_tel_link') ? undefined : json['has_tel_link'],
        'underlined': !exists(json, 'underlined') ? undefined : json['underlined'],
        'color': !exists(json, 'color') ? undefined : json['color'],
    };
}

export function DatabaseTelnumberFieldToJSON(value?: DatabaseTelnumberField | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatabaseFieldToJSON(value),
        'has_tel_link': value.hasTelLink,
        'underlined': value.underlined,
        'color': value.color,
    };
}

